import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import RelativeLink from "../common/RelativeLink";
import { connect } from "react-redux";
import { formatValidatieStatussesForSideNav } from "./NavItemHelper";
import { Popup } from 'semantic-ui-react';

const SideNav = ({ items, routePrefix, scope, accountId, accountType }) => {
	let windowStyle = {};
	windowStyle.left = '-12px';
	windowStyle.marginLeft = '0px';
	return (<aside className={"c-reactsidenav"}>
		{items.map((item, i) => {
			const link = item.linkEnabled ?
				item.display.length > 14 ?
					<div key={i + 1}><Popup trigger={<div className="c-reactsidenav__item truncated"><RelativeLink to={scope + "/" + routePrefix + "/" + accountType + "/" + accountId + item.url}>{item.display}</RelativeLink></div>} content={item.display} /></div>
					:
					<RelativeLink key={i + 1} className="c-reactsidenav__item truncated" to={scope + "/" + routePrefix + "/" + accountType + "/" + accountId + item.url}>{item.display}</RelativeLink>
				:
				<div className="disabled c-reactsidenav__item truncated">{item.display}</div>;
			return link;
		})}
	</aside>
	);
};

SideNav.propTypes = {
	items: PropTypes.array,
	scope: PropTypes.string,
	routePrefix: PropTypes.string,
	accountId: PropTypes.string,
	accountType: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		scope: state.layout.scope,
		items: formatValidatieStatussesForSideNav(state.validatieStatussen),
		routePrefix: state.layout.sideNavPrefix,
		accountId: state.settings.accountId,
		accountType: state.settings.accountType
	};
}

export default connect(mapStateToProps)(withRouter(SideNav));
